<template>
    <div class="page-wrapper bg-white radius-lg margin-left-sm">
        <div class="search-container min flex align-center  justify-end padding-lr margin-top-sm">
            <el-button class="btn min bg-orange radius" type="warning" @click="addClassify(false)">
                添加
            </el-button>
        </div>
        <div class="page-list flex flex-direction padding flex-sub">
            <el-table
                v-loading="loading"
                :data="lists"
                border
                header-row-class-name="table-header"
                style="width: 100%">
                <el-table-column label="类别" prop="name">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="end_time" width="370">
                    <template slot-scope="scope">
                        <div class="table-operate text-center" v-if="scope.row.oid">
                            <el-button class="radius" type="primary" size="small" @click="addClassify(scope.row)">编辑</el-button>
                            <el-button class="radius" type="danger" size="small" @click="delClassify(scope.row)">删除</el-button>
                        </div>
                        <div class="table-operate text-center" v-else>
                          --
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top self-end"
                layout="prev, pager, next"
                @current-change="init">
            </el-pagination>
        </div>
        <add-classify-dialog :dialog-visible="addClassifyDialog" :uid="cur_id" :name="cur_name" @watchState="watchState"></add-classify-dialog>
    </div>
</template>

<script>

import {delProjectCate, getProjectCateList} from "@/api";
import AddClassifyDialog from "@/views/web/admin/components/AddClassifyDialog";
import {confirm, TOAST, toast} from "@/utils/utils";

export default {
    name: "project-classify",
    components: {AddClassifyDialog},
    data() {
        return {
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            cur_id:0,
            cur_name:'',
            addClassifyDialog:false,
        }
    },
    created() {
        this.$emit('setIndex', [1,9], '项目类别管理', false)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            this.loading = true
            let _data = await getProjectCateList(this.page,this.limit)
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        menuChange(value) {
            this.curTab = value
            this.search()
        },
        search(){
            this.page = 1
            this.init()
        },
        addClassify(data){
            if (data) {
                this.cur_id = data.id
                this.cur_name = data.name
            }
            this.addClassifyDialog = true
        },
        watchState(data) {
            if (data) this.init()
            this.cur_id = 0
            this.cur_name = ''
            this.addClassifyDialog = false
        },
        delClassify(item){
            confirm(`删除单位`,`你确定删除<b>${item.name}</b>类别吗？`,()=>{
                this.delClassifyItem(item.id)
            },'确认',true)
        },
        async delClassifyItem(id){
            let _data = await delProjectCate(id)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
}
</style>
